<template>
  <div class="baseContent-warp">
  <Card class="menu-card">
    <el-menu slot="title" :default-active="activeIndex" mode="horizontal" @select="handleSelect">
      <el-menu-item index="1">病症标签</el-menu-item>
      <el-menu-item index="2">运营标签</el-menu-item>
      <el-menu-item index="3">运营标签分类</el-menu-item>
    </el-menu>
    <div slot="content">
      <MaladyLabel v-if="menuIndex == 1"/>
      <OperateLabel v-if="menuIndex == 2"/>
      <OperateLabelTitle v-if="menuIndex == 3"/>
    </div>
  </Card>
  </div>
</template>

<script lang="js">
import MaladyLabel from "./MaladyLabel.vue"; // 病症标签
import OperateLabel from "./OperateLabel.vue"; // 运营标签
import OperateLabelTitle from "./OperateLabelTitle.vue"; // 运营标签类型
export default {
  name: "LabelMange",
  components: { MaladyLabel, OperateLabel, OperateLabelTitle },
  data() {
    return {
      activeIndex: "1", // 默认激活菜单
      menuIndex: "1", // 菜单索引
    }
  },
  created() {
    let index = this.$session.get('labelIndex');
    if (index) this.activeIndex = this.menuIndex = index;
  },
  methods:{
    // 切换当前显示组件
    handleSelect(key) {
      this.menuIndex = key;
      this.$session.set('labelIndex', key);
    }
  }
};
</script>